// extracted by mini-css-extract-plugin
export default {"banner":"TrialBanner_banner__ITRG5","inner":"TrialBanner_inner__AztBr","tag":"TrialBanner_tag__0Etcf","terms":"TrialBanner_terms__ZS13p"};